/**
 * PageHero — shared editorial hero for list pages (Artists, Artworks,
 * Exhibitions, Journal, Film, Contact). All content flows from the CMS.
 * Design (typography, spacing, animation) is a verbatim extract of the
 * per-page hero markup so nothing shifts visually.
 */
export default function PageHero({ overline, title, intro, testid }) {
    return (
        <header className="reveal max-w-3xl" data-testid={testid || 'page-hero'}>
            {overline && (
                <span
                    className="overline"
                    style={{ color: 'var(--ink-2)' }}
                    data-testid="page-hero-overline"
                >
                    {overline}
                </span>
            )}
            <h1
                className="mt-8"
                data-testid="page-hero-title"
                style={{
                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                    fontWeight: 400,
                    fontSize: 'clamp(46px, 6.6vw, 110px)',
                    lineHeight: 0.96,
                    letterSpacing: '-0.025em',
                }}
            >
                <em className="serif-italic" style={{ fontWeight: 500 }}>{title}</em>
            </h1>
            {intro && (
                <p
                    className="mt-10 max-w-xl"
                    data-testid="page-hero-intro"
                    style={{
                        fontFamily: "'Cormorant Garamond', Georgia, serif",
                        fontWeight: 400,
                        fontSize: 19,
                        lineHeight: 1.7,
                        color: 'var(--ink-2)',
                    }}
                >
                    {intro}
                </p>
            )}
        </header>
    );
}
